import { join } from "path";

const CONTENT_DIR = "_content";
const TEMPLATES_DIR = "templates";

export const HUB_DIR = "hub";
export const INCLUDES_DIR = "includes";
export const PORTAL_DIR = "portal";

export const CODE_SAMPLES_DIR = "code-samples";
export const GUIDES_DIR = "guides";
export const LABS_DIR = "labs";
export const TEMPLATES_CATEGORY_DIR = "templates";
export const ARTICLES_DIR = "articles";
export const STORIES_DIR = "stories";
export const WORKSHOPS_DIR = "workshops";
export const GET_STARTED_DIR = "get-started";
export const WEBINARS_DIR = "webinars";

export const CONTENT_PATH = join(process.cwd(), "..", "..", CONTENT_DIR);
export const API_CONTENT_PATH = join(process.cwd(), CONTENT_DIR);

export const INCLUDES_PATH = join(CONTENT_PATH, INCLUDES_DIR);
export const API_INCLUDES_PATH = join(API_CONTENT_PATH, INCLUDES_DIR);

export const TEMPLATES_PATH = join(CONTENT_PATH, TEMPLATES_DIR);
export const API_TEMPLATES_PATH = join(API_CONTENT_PATH, TEMPLATES_DIR);

export const DEV_CENTER_AUTH0_SIGNUP_URL =
  "https://auth0.com/signup/?utm_source=devcenter&utm_medium=auth0&utm_campaign=devn_signup";
